<template lang="pug" >
div.kpi-cards(v-if="loadingKpi")
    ods-kpi(
     :ammount='ammount' href='/#/loyalty/accounts').kpi-cards__body
     div.kpi-cards__title(slot='title' v-if="allAccounts")
      span.kpi-cards__square-title-text {{ title }}
     div.kpi-cards__title(slot='title' v-else)
      div.kpi-cards__square
        div.kpi-cards__square-content(:style="{'background-color': color}")
      span.kpi-cards__square-text {{ title }}
    div(v-if="!isBlocked").bar
      ods-progress(
        :percentage='percentage'
        :type='type'
        :color='color'
        :show-text="showText"
        :width='parseInt(width)')
    div(v-else).bar-blocked
      ods-progress(
        :percentage='percentage'
        :type='type'
        :color='color'
        :show-text="showText"
        :width='parseInt(width)')
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    ammount: {
      type: String,
      required: true
    },
    title: {
      required: true
    },
    percentage: {
      required: true
    },
    type: {
      required: true
    },
    showText: {
      required: true
    },
    color: {
      required: false
    },
    width: {
      required: true
    },
    allAccounts: {
      required: true
    }
  },

  name: 'KpiCards',
  data: () => {
    return {
      loadingKpi: false,
      isBlocked: false
    }
  },
  mounted () {
    if (this.$props.name === 'blocked-counts') {
      this.isBlocked = true
    }
    this.loadingKpi = true
  }
}
</script>

<style lang="scss">
.kpi-cards{
padding: rem(18) rem(18) rem(18) rem(17);
height: 6.75rem;
opacity: 50;
flex: auto;
border: 1px solid #D7DADC;
border-top: none !important;
.kpi_arrow{
  display: none;
}

.kpi_title{
  padding-bottom: rem(32);
  color: #6E767D;
  min-width: 40%;
  max-width: 324px !important;
}

&__body{
  cursor: pointer;
}

&__title{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

&__square{
  width: 16px;
  height: 16px;
}

&__square-content{
  width: 100%;
  height: 100%;
  border-radius: 2px;
}

&__square-title-text{
  text-transform: initial;
  color: #6E767D;
}

&__square-text{
  display: flex;
  width: 75%;
  text-transform: initial;
  text-align: left;
  color: #6E767D;
  margin-left: 5px;
}

}

.bar {
margin-top: -8px;
}

.bar-blocked {
margin-top: -18px;
}
</style>
